import {MutableRefObject} from "react";
import {css, Theme} from "@emotion/react";

import {w100} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";

import {getCountryId} from "../../../offer/list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {propertyConfiguratorSearchFormFields} from "../../../property_configurator/reducers/property_configurator_reducer";
import {Country} from "../../../region/types/Country";
import {IFetchAllSearchListsParams} from "../../actions/fetch_search_all_action";
import {searchFormFields} from "../../constants/search_form_constants";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {SearchAutocomplete} from "./SearchAutocomplete";
import {SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

interface IProps {
    onDropdownStatusChange: (isOpen: boolean) => void;
    formProps: {
        formValues: SearchFormValuesType;
        formActions: FormActions<Record<keyof typeof searchFormFields | keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
        fetchAllSearchLists: (searchInput: string, params: IFetchAllSearchListsParams) => Promise<SearchTab>;
        latestQuery?: {country?: string};
    };
    onAfterChange?: (name: string, value: unknown) => void;
    onSearchSubmit: () => void;
    onAfterTabSwitch: () => void;
    onInputMount: (ref: MutableRefObject<HTMLInputElement | null>) => void;
    isInModal?: boolean;
    showSelectedUnderInput?: boolean;
    onInputClick?: () => void;
    inputDisabled?: boolean;
    includeDistanceFilter?: boolean;
    placeholder?: string;
    showArrowOnMobile?: boolean;
    disableMultiRegion?: boolean;
    isDropdownOpen?: boolean;
}

export const SearchAutocompleteWithDropdown = (props: IProps) => {
    const {
        onDropdownStatusChange,
        formProps,
        onAfterChange,
        onSearchSubmit,
        onAfterTabSwitch,
        onInputMount,
        isInModal,
        showSelectedUnderInput,
        onInputClick,
        inputDisabled,
        includeDistanceFilter = true,
        placeholder = "Gdzie chcesz mieszkać",
        showArrowOnMobile,
        disableMultiRegion,
        isDropdownOpen
    } = props;
    const searchCountry = getCountryId(props.formProps.latestQuery?.country) || Country.POLAND;

    return (
        <div css={[searchAutocompleteWrapper, showSelectedUnderInput && w100]}>
            <SearchAutocomplete
                values={formProps.formValues}
                onChange={formProps.formActions.update}
                onAfterChange={onAfterChange}
                onSubmit={onSearchSubmit}
                onDropdownStatusChange={onDropdownStatusChange}
                onAfterTabSwitch={onAfterTabSwitch}
                inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                placeholder={placeholder}
                fetchAllSearchLists={(input, params) => formProps.fetchAllSearchLists(input, {...params, country: searchCountry})}
                isInModal={isInModal}
                showSelectedUnderInput={showSelectedUnderInput}
                onInputMount={!isInModal ? onInputMount : undefined}
                includeDistanceFilter={includeDistanceFilter}
                onInputClick={onInputClick}
                inputDisabled={inputDisabled}
                showArrowOnMobile={showArrowOnMobile}
                disableMultiRegion={disableMultiRegion}
                isDropdownOpen={isDropdownOpen}
                renderDropdownList={(props) => (
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={props.dropdownIsOpen}
                        search={props.search}
                        selectedTab={props.selectedTab}
                        onLinkClick={props.onLinkClick}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        offers={props.offers}
                        places={props.places}
                        regions={props.regions}
                        removeRegionTag={props.removeRegionTag}
                        vendors={props.vendors}
                        getFieldProps={props.getFieldProps}
                    />
                )}
            />
        </div>
    );
};

const searchAutocompleteWrapper = (theme: Theme) => css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 0;
        max-height: 100%;
        width: 100%;
    }
`;
import {MutableRefObject} from "react";
import {css, Theme} from "@emotion/react";

import {w100} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";

import {getCountryId} from "../../../offer/list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {propertyConfiguratorSearchFormFields} from "../../../property_configurator/reducers/property_configurator_reducer";
import {Country} from "../../../region/types/Country";
import {IFetchAllSearchListsParams} from "../../actions/fetch_search_all_action";
import {searchFormFields} from "../../constants/search_form_constants";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {SearchAutocomplete} from "./SearchAutocomplete";
import {SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

interface IProps {
    onDropdownStatusChange: (isOpen: boolean) => void;
    formProps: {
        formValues: SearchFormValuesType;
        formActions: FormActions<Record<keyof typeof searchFormFields | keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
        fetchAllSearchLists: (searchInput: string, params: IFetchAllSearchListsParams) => Promise<SearchTab>;
        latestQuery?: {country?: string};
    };
    onAfterChange?: (name: string, value: unknown) => void;
    onSearchSubmit: () => void;
    onAfterTabSwitch: () => void;
    onInputMount: (ref: MutableRefObject<HTMLInputElement | null>) => void;
    isInModal?: boolean;
    showSelectedUnderInput?: boolean;
    onInputClick?: () => void;
    inputDisabled?: boolean;
    includeDistanceFilter?: boolean;
    placeholder?: string;
    showArrowOnMobile?: boolean;
    disableMultiRegion?: boolean;
    isDropdownOpen?: boolean;
}

export const SearchAutocompleteWithDropdown = (props: IProps) => {
    const {
        onDropdownStatusChange,
        formProps,
        onAfterChange,
        onSearchSubmit,
        onAfterTabSwitch,
        onInputMount,
        isInModal,
        showSelectedUnderInput,
        onInputClick,
        inputDisabled,
        includeDistanceFilter = true,
        placeholder = "Gdzie chcesz mieszkać",
        showArrowOnMobile,
        disableMultiRegion,
        isDropdownOpen
    } = props;
    const searchCountry = getCountryId(props.formProps.latestQuery?.country) || Country.POLAND;

    return (
        <div css={[searchAutocompleteWrapper, showSelectedUnderInput && w100]}>
            <SearchAutocomplete
                values={formProps.formValues}
                onChange={formProps.formActions.update}
                onAfterChange={onAfterChange}
                onSubmit={onSearchSubmit}
                onDropdownStatusChange={onDropdownStatusChange}
                onAfterTabSwitch={onAfterTabSwitch}
                inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                placeholder={placeholder}
                fetchAllSearchLists={(input, params) => formProps.fetchAllSearchLists(input, {...params, country: searchCountry})}
                isInModal={isInModal}
                showSelectedUnderInput={showSelectedUnderInput}
                onInputMount={!isInModal ? onInputMount : undefined}
                includeDistanceFilter={includeDistanceFilter}
                onInputClick={onInputClick}
                inputDisabled={inputDisabled}
                showArrowOnMobile={showArrowOnMobile}
                disableMultiRegion={disableMultiRegion}
                isDropdownOpen={isDropdownOpen}
                renderDropdownList={(props) => (
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={props.dropdownIsOpen}
                        search={props.search}
                        selectedTab={props.selectedTab}
                        onLinkClick={props.onLinkClick}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        offers={props.offers}
                        places={props.places}
                        regions={props.regions}
                        removeRegionTag={props.removeRegionTag}
                        vendors={props.vendors}
                        getFieldProps={props.getFieldProps}
                    />
                )}
            />
        </div>
    );
};

const searchAutocompleteWrapper = (theme: Theme) => css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 0;
        max-height: 100%;
        width: 100%;
    }
`;
